// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".container--Erplp{width:100%}", "",{"version":3,"sources":["webpack://./src/taskpane/components/NextMoveAnalysis/NextMoveAnalysis.module.scss"],"names":[],"mappings":"AAAA,kBACE,UAAA","sourcesContent":[".container {\n  width: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "container--Erplp"
};
module.exports = ___CSS_LOADER_EXPORT___;
